import React from 'react';
import { RETAILER } from '../../config';

// Components
import FullPageLayout from '../../components/FullPageLayout';
import { Container } from 'reactstrap';

const NoLoyaltyCard = ({ userId, cardNumber }) => (
  <FullPageLayout>
    <Container style={{paddingTop: '2rem', paddingBottom: '2rem'}}>

      <h1 className="Version_title">
        Can't earn with your account
      </h1>

      <div>{`No ${RETAILER} loyalty card is available for your account`}</div>

    </Container>
  </FullPageLayout>
)

export default NoLoyaltyCard;



// WEBPACK FOOTER //
// ./src/pages/NoLoyaltyCard/NoLoyaltyCard.js